import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { DGMessage } from '../common/deepgramUtils';
import { baseConfig, stsConfig } from '../common/constants';
import { StsQueryParamsService } from './sts-query-params.service';

@Injectable({
  providedIn: 'root'
})

export class DeepgramAgentService {
  private deepgramAgentWSUrl = environment.deepgramAgentWSURL;
  private apiKey = '';

  private socket!: WebSocket;
  private reconnectAttempts = 0;
  private maxReconnectAttempts = 5;
  private keepAliveInterval: any;

  private socketOpenSubject = new Subject<void>();
  private socketMessageSubject = new Subject<any>();
  private socketCloseSubject = new Subject<void>();
  private socketErrorSubject = new Subject<Event>();

  socketOpen$ = this.socketOpenSubject.asObservable();
  socketMessage$ = this.socketMessageSubject.asObservable();
  socketClose$ = this.socketCloseSubject.asObservable();
  socketError$ = this.socketErrorSubject.asObservable();

  constructor() {}

  connect() {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      console.log('WebSocket is already connected.');
      return;
    }

    this.socket = new WebSocket(this.deepgramAgentWSUrl, [
      'token',
      this.apiKey
    ]);

    this.socket.onopen = () => {
      console.log('WebSocket Connected.');
      this.reconnectAttempts = 0;
      this.socketOpenSubject.next();

      this.startKeepAlive();
    };

    this.socket.onmessage = event => {
      console.log('Message received:', event.data);
      this.socketMessageSubject.next(event.data);
    };

    this.socket.onerror = error => {
      console.error('WebSocket Error:', error);
      this.socketErrorSubject.next(error);
    };

    this.socket.onclose = () => {
      console.log('WebSocket Closed.');
      this.socketCloseSubject.next();
      this.stopKeepAlive();

      /*if (this.reconnectAttempts < this.maxReconnectAttempts) {
        setTimeout(() => this.connect(), 3000);
        this.reconnectAttempts++;
      }*/
    };
  }

  sendKeepAliveMessage() {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify({ type: 'KeepAlive' }));
      console.log('KeepAlive message sent.');
    }
  }

  startKeepAlive() {
    this.stopKeepAlive(); // Ensure no duplicate intervals
    this.keepAliveInterval = setInterval(
      () => this.sendKeepAliveMessage(),
      5000
    );
  }

  stopKeepAlive() {
    if (this.keepAliveInterval) {
      clearInterval(this.keepAliveInterval);
      this.keepAliveInterval = null;
    }
  }

  sendMessage(message: string) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(message);
    } else {
      console.error('WebSocket is not connected.');
    }
  }

  sendAudioChunk(chunk: ArrayBuffer) {
    if (this.socket?.readyState === WebSocket.OPEN) {
      this.socket.send(chunk);
    }
  }

  disconnect() {
    this.stopKeepAlive();
    if (this.socket) {
      this.socket.close();
    }
  }

  getSocket(): WebSocket {
    return this.socket;
  }
}
